var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-page',[_c('form-mail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }